module.exports = __webpack_public_path__ + "img/LogoText.50a3ea6d.svg";